import { AttendanceRuleFormValue, TimeBasedPackageFormValues } from './types';

export const validateEventTypes = (
  values: Pick<TimeBasedPackageFormValues, 'attendanceRules'>,
  path: string,
): string | null => {
  const attendanceRuleIndex = Number(path.split('.')[1]);
  const kiloClassTypes = values.attendanceRules[attendanceRuleIndex].kiloClassTypes;
  const appointmentTypes = values.attendanceRules[attendanceRuleIndex].appointmentTypes;
  if (kiloClassTypes.length + appointmentTypes.length == 0) {
    return 'Please select event types';
  }
  return null;
};

export const validateAthleteEndStatus = (
  values: Pick<TimeBasedPackageFormValues, 'athleteStatusOnStart' | 'athleteStatusOnEnd'>,
): string | null => {
  if (
    values.athleteStatusOnStart !== 'No status change' &&
    values.athleteStatusOnEnd !== 'No status change' &&
    values.athleteStatusOnStart === values.athleteStatusOnEnd
  ) {
    return 'Cannot select the same status as start';
  }
  return null;
};

export const isLimitedAttendanceRule = (
  rule: Pick<AttendanceRuleFormValue, 'credits' | 'isInfiniteSessions'>,
): boolean => rule.credits !== null && rule.credits > 0 && !rule.isInfiniteSessions;

export const validateHasLimitedAttendanceRule = (
  values: Pick<TimeBasedPackageFormValues, 'attendanceRules'>,
  message: string,
): string | null => (values.attendanceRules.some(isLimitedAttendanceRule) ? null : message);
